export const itemsPerPage = 25
export const LOADING_TEXT = 'Loading...'
export const notCompletedEmptyText =
  'No one has completed any of these practices yet.'
export const notSetupText = 'This site has not been set up yet.'

export const PRACTICE_TYPES = {
  EDUCATOR_PRACTICE: 'educator',
  SCHOOLWIDE_PRACTICE: 'sitewide',
  STUDENT_ACTIVITY: 'activity',
}

export const PROGRAM_KEYS = {
  HS: 'HS',
  HS_MONITOR: 'HS_MONITOR',
}

export const sortOrders = {
  asc: 'asc',
  desc: 'desc',
}

export const studentActivitiesEmptyText =
  'Your site is not requiring student activities in its current implementation.'
